const badgeColors = [
  'green',
  'amber',
  'gray',
  'stone',
  'yellow',
  'sky',
  'indigo',
  'purple',
  'lime',
  'red',
];

const getRandomColor = () => {
  return badgeColors[Math.floor(Math.random() * badgeColors.length)];
};

const getDeterministicColor = (id: string) => {
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash = (hash << 5) - hash + id.charCodeAt(i);
    hash |= 0;
  }
  return badgeColors[Math.abs(hash) % badgeColors.length];
};

export default getRandomColor;
export { getDeterministicColor };
